<div class="box-container">
    <div class="container">
        
        <div class="d-flex justify-content-center mt-3 col-md-12 content-container ">
            <div class="col-md-3 purchase-summary shadow trip-detail" style="overflow-y: auto;max-height: 100%;" >
                <div >
                  
                <h2 style="text-align: center; border-radius:4px;" class=" " style="text-shadow: 2px 2px 5px rgb(0, 123, 255);">Purchase Summary</h2>
            </div>
                <div class="trip-details ">
                    <h3 >Trip Name</h3>
                    
                    <span class="d-flex justify-content-start" style="font-size: 20px;color: grey;">{{tripResponse?.tripName}}</span>
                </div>
                <div class="trip-details mt-2">
                    <h3>Estimated Trip Total</h3>
                    <p class="col-md-12"><label style="color: dodgerblue;">Air&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :&nbsp;</label> <span style="font-size: 14px;color: grey;">{{airTotal}} INR</span></p>
                    <mat-divider></mat-divider>
                    <!-- <p><label style="color: dodgerblue;">Hotel :&nbsp;</label> <span style="font-size: 14px;color: grey;">{{hotelTotal}} INR</span></p>
                    <mat-divider></mat-divider> -->
                    <p><label style="color: dodgerblue;">Total &nbsp;:&nbsp;</label> <span style="font-size: 14px;color: grey;">{{airTotal+hotelTotal}} INR</span></p>
                </div>
                <div class="trip-details mt-2">
                    <h3>Lowest Logical Fare</h3>
                    <p><label style="color: dodgerblue;" >Air&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</label> <span style="font-size: 14px;color: grey;">{{airTotal}} INR</span></p>
                    <mat-divider></mat-divider>

                    <!-- <p><label style="color: dodgerblue;" >Hotel&nbsp;:&nbsp;</label> <span style="font-size: 14px;color: grey;">{{hotelTotal}} INR</span></p> -->
                </div>
                <!-- <div  *ngIf="tripResponse?.status==='N'&&!tripUid&&bookStatus===false" class="d-flex justify-content-right; " style="padding-top: 30px;">
 <button (click)="onClickAir()" mat-flat-button  style="margin-right: 8px; background-color: #1876D0;color:#ffffff" > Rebook</button>
 <button (click)="onClickHotel()" mat-flat-button  style="background-color: #1876D0;color:#ffffff"> Add Hotel</button>
</div> -->
<mat-divider class="mt-2"></mat-divider>

<div *ngIf="hotelList.length+airList.length!=0&&tripResponse.status==='N'&&!tripUid&&tripEnable===false" class="mt-1" >
    <!-- <mat-label>Trip Discription</mat-label> -->
  <!-- <textarea  matInput name="discription" id="" [(ngModel)]="approvalDescription" cols="30" rows="1" maxlength="100"></textarea> -->
  <button  mat-flat-button class="status-button"  style="background-color: #18b8d0;color:#ffffff;width:100% ; " (click)="tripApproval()"> Submit for Approval </button>


</div>
<div *ngIf="hotelList.length+airList.length!=0&&tripResponse.status!='N'&&tripEnable===false" class="mt-1" >
  <!-- <mat-label>Trip Discription</mat-label> -->
<!-- <textarea  matInput name="discription" id="" [(ngModel)]="approvalDescription" cols="30" rows="1" maxlength="100"></textarea> -->
<button *ngIf="tripResponse.status!='A'" mat-flat-button  class="status-button" style="background-color: #18b8d0;color:#ffffff;width:100% ;cursor:default; " disabled >{{tripResponse?.statusDesc}}</button>
<button *ngIf="tripResponse.status==='A'&&!tripUid" class="status-button" (click)="tripBooked()" mat-flat-button  style="background-color: #18b8d0;color:#ffffff;width:100% ;; "  >{{'Book Trip Now'}}</button>


</div>


<div *ngIf="hotelList.length+airList.length!=0&&tripResponse.status==='N'&&!tripUid&&tripEnable===true&&bookStatus===true" class="mt-1" >
  <!-- <mat-label>Trip Discription</mat-label> -->
<!-- <textarea  matInput name="discription" id="" [(ngModel)]="approvalDescription" cols="30" rows="1" maxlength="100"></textarea> -->
<button  mat-flat-button  class="status-button" style="background-color: #18b8d0;color:#ffffff;width:100% ; " (click)="tripApproval()"> Submit for Approval </button>


</div>
<div *ngIf="hotelList.length+airList.length!=0&&tripResponse.status!='N'&&tripEnable===true" class="mt-1" >
<!-- <mat-label>Trip Discription</mat-label> -->
<!-- <textarea  matInput name="discription" id="" [(ngModel)]="approvalDescription" cols="30" rows="1" maxlength="100"></textarea> -->
<button  mat-flat-button         class="status-button" 
style="background-color: #18b8d0;color:#ffffff;width:100% ;cursor:default; " disabled >{{tripResponse?.statusDesc}}</button>
<!-- <button *ngIf="tripResponse.status==='A'&&!tripUid" (click)="tripBooked()" mat-flat-button  style="background-color: #18b8d0;color:#ffffff;width:100% ;; "  >{{'Book Trip Now'}}</button> -->


</div>
<!-- <button 
        mat-flat-button  *ngIf="showCancel"
        class="cancel-button" 
         (click)="popoverCancelContent.toggle($event)">Cancel Trip
</button> -->



            </div>

            <div class="col-md-9 itinerary shadow">
              <div >
                
           


<p-overlayPanel    #popoverCancelContent class="col-md-12" [style]="{'max-width':'60rem'}" >
  <table  class="poptable">
    <thead >
        <tr class="sticky-tabs">
            <th>Departure</th>
            <th>Summary</th>

            <th>Booking Status</th>
            <th>Action</th>

        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of airList">
        <td>  <span *ngIf="element.status==='B'" >
          <span *ngIf="element?.airItineraries&&element?.airItineraries.length>0">

      <pre>{{formatDate(element?.airItineraries[0]?.firstDeparture)}}</pre>  </span> </span>
        <span *ngIf="element.status!='B'" ><pre> {{formatDate(element?.requestedDate)}}</pre></span> </td>
        <td> <span *ngIf="element.status!='B'" > <pre>{{element.fromAirport+'-'+element.toAirport}}</pre></span> 
          <span *ngIf="element.status==='B'" > 
           <span *ngFor="let Itineraries of element.airItineraries" ><pre>{{Itineraries?.sector}}|{{formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}|{{Itineraries?.airline}}-{{Itineraries?.flightNumber}}|{{element?.itineraryCost||0}} INR</pre></span>
         </span> </td>
        <td> <button *ngIf="element.status==='B'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>BOOKED</button>
          <!-- <button  *ngIf="element.status!='B'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button> -->
          <button  *ngIf="element.status==='D'" style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
</td>
        <td>
          <button  (click)="onClickSingleCancel(element)"
          mat-flat-button  *ngIf="element.status==='B'"
          class="cancel-button" 
           >Cancel
       </button></td>

      </tr>
       
    </tbody>
    </table>
   <button 
   mat-flat-button  *ngIf="showCancel"
   class="cancel-button" 
   (click)="onClickCancel()" >Cancel&nbsp;Complete&nbsp;Trip
</button>
  </p-overlayPanel>
  <div *ngIf="!tripUid" class="button-group">
  <button 
  mat-flat-button  *ngIf="showCancel&&!disableCancel"
  class="cancel-button" 
   (click)="popoverCancelContent.toggle($event)">Cancel&nbsp;Trip
</button>
<mat-progress-bar *ngIf="disableCancel" mode="indeterminate"></mat-progress-bar>


</div>
                <div *ngIf="tripUid&&tripResponse.status==='I'" class="button-group">
                  <button  class="approve-button" (click)="Approve()">Approve</button>
                  <button style="margin-left: 20px;"  class="reject-button" (click)="Reject()">Reject</button>
                </div>
              </div>
                <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="pb-2" style="text-align: left;">
                 
                    <mat-tab  >
                        <ng-template mat-tab-label>
                            Air&nbsp;<span [matBadge]="airList.length||0" matBadgeSize="medium" matBadgeOverlap="false"> </span>
                          </ng-template> 
               

                
                <!-- <div class="price">
                    <label>Price:</label> <span>$XXX</span>
                </div> -->
                <!-- <div class="special-requests">
                    <h3>Special Requests</h3>
                    <textarea placeholder="Enter any special requests here"></textarea>
                </div> -->
               
<div style=" max-height: 75vh;min-height: 75vh;overflow-x: auto;margin-top: 10px;">
                <table mat-table  style="font-size: 18px;"
                [dataSource]="airList" multiTemplateDataRows style="background-color: transparent;">
                <ng-container matColumnDef="expand">
                <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;<button mat-icon-button (click)="refresh()"> <mat-icon style="color: #1876D0;cursor: pointer;" >refresh</mat-icon></button>
                </th>
                <td mat-cell *matCellDef="let element">
                <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                  <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
                  <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
                </button>
                </td>
                </ng-container>
                <ng-container matColumnDef="generationTime">
                 <th mat-header-cell *matHeaderCellDef> Generation Time </th>
                 <td mat-cell *matCellDef="let element;"> {{formatDate(element?.bookingTs)}} </td>
                </ng-container>
                <!-- Emp Id -->
                 <ng-container matColumnDef="firstDeparture">
                   <th mat-header-cell *matHeaderCellDef>Departure</th>
                   
                   <td mat-cell *matCellDef="let element"> 
                    <span *ngIf="element.status==='B'" >
                      <span *ngIf="element?.airItineraries&&element?.airItineraries.length>0">

                  <pre>{{formatDate(element?.airItineraries[0]?.firstDeparture)}}</pre>  </span> </span>
                    <span *ngIf="element.status!='B'" ><pre> {{formatDate(element?.requestedDate)}}</pre></span>

                    
                    <!-- airItineraries[0]?.flightDetails?.flightDetailsList[0]?.schDepartureTime -->
                   </td>
                 </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="cartId">
                  <th mat-header-cell *matHeaderCellDef> CartId </th>
                  <td mat-cell *matCellDef="let element"> {{element?.cartId}} </td>
                 </ng-container>
                 <ng-container matColumnDef="failedAttempts">
                  <th mat-header-cell *matHeaderCellDef> Failed Attempts </th>
                  <td mat-cell *matCellDef="let element"> {{element?.failedAttempts}} </td>
                 </ng-container>
                 
                <ng-container matColumnDef="bookedBy">
                 <th mat-header-cell *matHeaderCellDef> Booking Fee </th>
                 <td mat-cell *matCellDef="let element"><span *ngFor="let airItineraries of element.airItineraries"> {{airItineraries?.repriceData?.fare.baseFare?(airItineraries.repriceData?.fare?.baseFare):0+airItineraries?.repriceData?.fare?.finalTax?(airItineraries.repriceData?.fare?.finalTax):0+airItineraries?.commissionData?.finalAmount?(airItineraries?.commissionData?.finalAmount):0}} INR</span> </td>

                 <!-- <td mat-cell *matCellDef="let element"> {{element?.createdBy?.split('-')[1]}} </td> -->
                </ng-container>
                
                <!-- email Column -->
                <ng-container matColumnDef="corporate_Agent">
                 <th mat-header-cell *matHeaderCellDef>Corporate/Agent  </th>
                 <td mat-cell *matCellDef="let element"> {{element?.corporate?.split('-')[1]||'-'}} </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>Invoice Status </th>
                  <td mat-cell *matCellDef="let element" [style]="element?.invoiceStatus==='S'?('background-color:rgb(25, 143, 25);color:white'):element?.invoiceStatus==='P'?('background-color:rgb(231, 75, 75);color:white'):element?.invoiceStatus==='N'?('background-color:orange;color:white'):''">
                     <!-- {{element?.invoiceStatus}}  -->
                     {{element?.invoiceStatus==='N'?('NEW'):''}}
                      {{element?.invoiceStatus==='P'?('PENDING'):''}}
                      {{element?.invoiceStatus==='S'?('SUCCESS'):''}}
                    
                    </td>
                 </ng-container>
                 <ng-container matColumnDef="summary">
                  <th mat-header-cell *matHeaderCellDef>Summary </th>
                  <td mat-cell *matCellDef="let element" style="padding: 4px;">
                   <span *ngIf="element.status!='B'" > <pre>{{element.fromAirport+'-'+element.toAirport}}</pre></span> 
                   <span *ngIf="element.status==='B'" > 
                    <span *ngFor="let Itineraries of element.airItineraries" ><pre>{{Itineraries?.sector}}|{{formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}|{{Itineraries?.airline}}-{{Itineraries?.flightNumber}}|{{element?.itineraryCost||0}} INR</pre></span>
                  </span> 

                   <!-- <span style="background-color: #FF0000;color: red;" *ngIf="element.status!='B'"><pre>{{this.summary}}</pre></span> -->
                   <!-- <span *ngFor="let Itineraries of element.airItineraries" ><pre>{{Itineraries?.airline}}-{{Itineraries?.flightNumber}}|{{Itineraries?.sector}}|{{formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</pre></span> -->
                     </td>
                 </ng-container>
                 
                 <ng-container matColumnDef="approvalStatus">
                  <th mat-header-cell *matHeaderCellDef>Approval Status </th>
                  <td mat-cell *matCellDef="let element"> 
                    <span *ngIf="tripResponse.status==='I'">
                      
                      <button  mat-flat-button  style="background-color: #d0c118;color:#ffffff;width:100% ;cursor:default; " disabled >{{tripResponse?.statusDesc}}</button>

                      <!-- {{element?.status==='NEW'?('FAILED'):tripResponse?.status==='BOOKED'?('BOOKED'):''}} -->
                    </span>
                    <span *ngIf="tripResponse.status==='A'">
                      
                      <button  mat-flat-button  style="background-color: #18b8d0;color:#ffffff;width:100% ;cursor:default; " disabled >APPROVED</button>

                    </span>
                    <span *ngIf="tripResponse.status==='D'">
                      
                      <button  mat-flat-button  style="background-color: #d04018;color:#ffffff;width:100% ;cursor:default; " disabled >Request Rejected</button>

                    </span>
                    
                    
                    <!-- {{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}} -->
                    <!-- <span > {{element?.approvalStatus==='SA'?('SELF APPROVED'):''}}
                        {{element?.approvalStatus==='P'?('PENDING'):''}}
                        {{element?.approvalStatus==='D'?('DECLINED'):''}}
                        {{element?.approvalStatus==='A'?('APPROVED'):''}}
        
                        {{element?.approvalStatus==='I'?('APPROVAL INITIATED'):''}}
                        {{element?.approvalStatus==='S'?('SEND FOR RECONSIDERATION'):''}}</span> -->
                    </td>
                 </ng-container>
                 
                 <ng-container matColumnDef="bookingStatus">
                  <th mat-header-cell *matHeaderCellDef>Booking Status</th>
                  
                  <td mat-cell *matCellDef="let element ; let i = dataIndex" class="d-flex justify-content-start pt-1">
                 <button *ngIf="element.status==='B'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>BOOKED</button>
                 <!-- <button  *ngIf="element.status!='B'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button> -->
                 <button  *ngIf="element.status==='D'" style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>

                 <span *ngIf="element.status!='B'&&element.status!='D'">
                  <button  *ngIf="i === (airList?.length || 0) - 1" (click)="onClickAir()" mat-flat-button  style=" background-color: rgb(212, 212, 11);color:#ffffff;min-width: 130px;" >BOOK NOW</button>
                 </span>
                 
                 
                 <!-- <button *ngIf="element.status==='Z'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
                 <button *ngIf="element.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>

                 <button  *ngIf="element.status==='N'||element.status==='P'||element.status==='S'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
                 <button  *ngIf="element.status==='R'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>PAYMENT FAILED</button>
  
                 <button  *ngIf="element.status==='A'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>ABORTED</button>
                 <button  *ngIf="element.status==='TC'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button >TO CANCEL</button>
                 <button  *ngIf="element.status==='C'" style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
                -->
  
                  </td>
                 </ng-container>
                 <ng-container matColumnDef="paymentStatus">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element">
                    <!-- {{element?.paymentStatus==='P'?('PAID'):''}}
                    {{element?.paymentStatus==='F'?('FAILED'):''}}
                    {{element?.paymentStatus==='I'?('INITIATED'):''}}
                    {{element?.paymentStatus==='A'?('ABORTED'):''}}
                    {{element?.paymentStatus==='U'?('UNPAID'):''}} -->
                    <button (click)="generatePDF(element,'C')" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 180px;" mat-flat-button>Download Ticket </button>

                  </td>
                 </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                <div class="example-element-detail row"
                 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                 <div class=" col-md-12  mt-2 mb-2 card shadow pb-3" *ngIf="element.status==='B'">
                
                       
  
                         
                  <div class="col-md-12 d-flex justify-content-start mt-2">
                    <div class="col-md-12  row">
                        <div class="trip-info" >
                           
                            <!-- <h5 class="mt-2">{{tripResponse?.statusDesc}}</h5> -->
                            <h6>{{''}}</h6>
                            <div *ngFor="let items of element.airItineraries">
                                <div class="col-md-12 title " >
                                  <div class="row">
                                  <div class="col-md-8 d-flex justify-content-end">
                                  <span>{{cityFilter(items?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(items?.flightDetails?.flightDetailsList[items?.flightDetails?.flightDetailsList.length-1]?.toAirport)}}</span>&nbsp;<span *ngIf="items?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(items?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span>
                                </div>
                                  <div  class=" col-md-4 d-flex justify-content-end">
                                    <div  class="stamp-container ">

                                  <span class="stamp-text">{{ getStatusDescription(items?.status) }}</span>
                               </div>
                                </div>
                              </div>
                              </div>
                                
                            <div class="flights pt-3" *ngFor="let item of items?.flightDetails?.flightDetailsList">
                                
                                <div class="flight-details">
                                  <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
            
                                   
                                  <div class="carrier-info">
                                    <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                    <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                  </div>
                                </div>
                                <svg class="line" width="800" height="100" >
                                    
                                    <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                    <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                    <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
            
                                    <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                    <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
              
                                    <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                                  </svg>
                                
        
                                 
                              </div>
                            </div>
                        </div>
                    <!-- <span class="col-md-12 "> 
                      <button (click)="onCartStatusClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>CART STATUS</button>
                      <button (click)="onModifyClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>MODIFY</button>
                      <button *ngIf="element.status==='Z'||element.status==='B'" mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" (click)="generatePDF(element)">Download as PDF</button>
   
                    </span> -->
                   
                    </div>
                    </div>
                  </div>
                </div>
                </td>
                </ng-container>
                <!-- [style]="element.status!='B'?('background-color:rgba(255, 115, 0, 0.727)'):''" -->
                <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"  ></tr>
                <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand"ß 
                class="example-element-row" sticky >
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"  class="example-detail-row"></tr>
                <tr class="mat-row" *matNoDataRow>
                <td  class="mat-cell" colspan="4">There is no data in this table</td>
                </tr>
                </table>
                <!-- <div  *ngIf="tripResponse?.status==='N'&&!tripUid&&bookStatus===false" class=" rebook " >
                  <button (click)="onClickAir()" mat-flat-button  style=" background-color: #1876D0;color:#ffffff;min-width: 140px;" ><mat-icon>refresh</mat-icon>Retry</button>
                 </div> -->
            </div>
            </mat-tab>
                <mat-tab  [disabled]="true"> 
                 <ng-template mat-tab-label>
                  &nbsp;<span style="background-color: #3F50B5;color: #fff;padding: 10px;border-radius: 4px;"  matBadgeSize="medium" matBadgeOverlap="false"> Accomodation : {{tripResponse.hotelRequired}} </span>

                  <!-- Hotel Required&nbsp;<span matBadgeSize="medium" matBadgeOverlap="true"> </span> -->
                </ng-template> 
                  <div style=" overflow: auto;max-height: 75vh;overflow-x: auto;">
                    <table mat-table  style="font-size: 18px;margin-top: 10px;"
                    [dataSource]="hotelList" multiTemplateDataRows style="background-color: transparent;">
                    <ng-container matColumnDef="expand">
                    <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;<button mat-icon-button (click)="refresh()">  <mat-icon style="color: #1876D0;cursor: pointer;" >refresh</mat-icon></button></th>
                    <td mat-cell *matCellDef="let element">
                    <button mat-icon-button aria-label="expand row" (click)="(expandedHElement = expandedHElement === element ? null : element); $event.stopPropagation()">
                      <mat-icon *ngIf="expandedHElement !== element">arrow_right</mat-icon>
                      <mat-icon *ngIf="expandedHElement === element">arrow_drop_down</mat-icon>
                    </button>
                    </td>
                    </ng-container>
                    <ng-container matColumnDef="generationTime">
                     <th mat-header-cell *matHeaderCellDef> Generation Time </th>
                     <td mat-cell *matCellDef="let element;"> {{formatDate(element?.creationTs)}} </td>
                    </ng-container>
                    <!-- Emp Id -->
                     <ng-container matColumnDef="firstDeparture">
                       <th mat-header-cell *matHeaderCellDef>Check-In</th>
                       
                       <td mat-cell *matCellDef="let element"> {{element?.searchRequest?.checkInDate}} </td>
                     </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="cartId">
                      <th mat-header-cell *matHeaderCellDef> CartId </th>
                      <td mat-cell *matCellDef="let element"> {{element?.uuid}} </td>
                     </ng-container>
                    <ng-container matColumnDef="bookedBy">
                     <th mat-header-cell *matHeaderCellDef> Booking Fee </th>
                     <td mat-cell *matCellDef="let element">
                     {{ element.hotelItineraries[0].hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.totalAmount}} INR
                      </td>
    
                     <!-- <td mat-cell *matCellDef="let element"> {{element?.createdBy?.split('-')[1]}} </td> -->
                    </ng-container>
                    
                    <!-- email Column -->
                    <ng-container matColumnDef="corporate_Agent">
                     <th mat-header-cell *matHeaderCellDef>Corporate/Agent  </th>
                     <td mat-cell *matCellDef="let element"> {{element?.corporate?.split('-')[1]||'-'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef>Invoice Status </th>
                      <td mat-cell *matCellDef="let element" [style]="element?.invoiceStatus==='S'?('background-color:rgb(25, 143, 25);color:white'):element?.invoiceStatus==='P'?('background-color:rgb(231, 75, 75);color:white'):element?.invoiceStatus==='N'?('background-color:orange;color:white'):''">
                         <!-- {{element?.invoiceStatus}}  -->
                         {{element?.invoiceStatus==='N'?('NEW'):''}}
                          {{element?.invoiceStatus==='P'?('PENDING'):''}}
                          {{element?.invoiceStatus==='S'?('SUCCESS'):''}}
                        
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="summary">
                      <th mat-header-cell *matHeaderCellDef>Summary </th>
                      <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                    {{ element.hotelItineraries[0].hotel}} 
                      
                        <!-- <span *ngFor="let Itineraries of element.airItineraries" ><pre>{{Itineraries?.airline}}-{{Itineraries?.flightNumber}}|{{Itineraries?.sector}}|{{formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</pre></span> -->
                       </td>
                     </ng-container>
                     
                     <ng-container matColumnDef="approvalStatus">
                      <th mat-header-cell *matHeaderCellDef> Status </th>
                      <td mat-cell *matCellDef="let element"> 
                        <span *ngIf="tripResponse.status!='A'">
                          {{tripResponse?.statusDesc}}
                        </span>
                        <span *ngIf="tripResponse.status==='A'">
                          APPROVED
                        </span>                        <!-- {{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}} -->
                        <!-- <span > {{element?.approvalStatus==='SA'?('SELF APPROVED'):''}}
                            {{element?.approvalStatus==='P'?('PENDING'):''}}
                            {{element?.approvalStatus==='D'?('DECLINED'):''}}
                            {{element?.approvalStatus==='A'?('APPROVED'):''}}
            
                            {{element?.approvalStatus==='I'?('APPROVAL INITIATED'):''}}
                            {{element?.approvalStatus==='S'?('SEND FOR RECONSIDERATION'):''}}</span> -->
                        </td>
                     </ng-container>
                     
                     <ng-container matColumnDef="bookingStatus">
                      <th mat-header-cell *matHeaderCellDef>Booking Status</th>
                      <td mat-cell *matCellDef="let element" class="d-flex justify-content-center pt-1">
                        <button *ngIf="element.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>
                        <button *ngIf="element.status==='PG'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>Pending</button>
                        <button *ngIf="element.status==='HP'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>Pending Hotel Confirmation</button>
                        <button *ngIf="element.status==='OK'"  disabled style="background-color:#44D43B;color:white;min-width: 130px;" mat-flat-button>Confirmed</button>
                        <button *ngIf="element.status==='CO'"  disabled style="background-color:#1ba511;;color:white;min-width: 130px;" mat-flat-button>Completed</button>
                        <button *ngIf="element.status==='PB'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
                        <button  *ngIf="element.status==='FD'" disabled style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
                        <button  *ngIf="element.status==='CN'" disabled style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
                   
      
                      </td>
                     </ng-container>
                     <ng-container matColumnDef="paymentStatus">
                      <th mat-header-cell *matHeaderCellDef>Action</th>
                      <td mat-cell *matCellDef="let element">
                        <!-- {{element?.paymentStatus==='P'?('PAID'):''}}
                        {{element?.paymentStatus==='F'?('FAILED'):''}}
                        {{element?.paymentStatus==='I'?('INITIATED'):''}}
                        {{element?.paymentStatus==='A'?('ABORTED'):''}}
                        {{element?.paymentStatus==='U'?('UNPAID'):''}} -->
                        <button (click)="onModifyHClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>View Cart </button>

                      </td>
                     </ng-container>
                    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                    <ng-container matColumnDef="expandedHDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayHWithExpand.length">
                    <div class="example-element-detail row"
                     [@detailExpand]="element == expandedHElement ? 'expanded' : 'collapsed'">
                     <div class=" col-md-12  mt-2 mb-2 card shadow pb-3">
                      <div class="trip-info">
                       
                        <!-- <h5 class="mt-2">{{tripResponse?.statusDesc}}</h5> -->
                        <h6>{{''}}</h6>
                        </div>
                        
                      <div class="booking-details">
                        <div class="d-flex justify-content-start">
                        <h4 >{{element?.hotelBooking?.selectedHotelOrder?.hotel?.name}}<span class="stars">
                          <small *ngFor="let start of starArray(element?.hotelBooking?.selectedHotelOrder?.hotel?.ratings[0]?.starRating)"> 
                                 <img  src="../../../assets/images/star.png" width="18" height="18" alt="">
                                 </small>
                       </span></h4>
                      </div>
                        <div class="check-in-out">
                          

                          
                            <div class="check-in">
                                <span>Check in</span>
                                <span>{{element?.hotelBooking?.hotelRequest?.checkInDate}}</span>
                            </div>
                            <div class="check-out">
                                <span>Check out</span>
                                <span>{{element?.hotelBooking?.hotelRequest?.checkOutDate}}</span>
                            </div>
                            <div class="total-rooms">
                                <span>Total Rooms</span>
                                <span>{{element?.hotelBooking?.hotelRequest?.roomCount}}</span>
                            </div>
                            <div class="total-stay">
                                <span>Total Stay</span>
                                <span>{{calculateStayNights(element?.hotelBooking?.hotelRequest?.checkInDate,element?.hotelBooking?.hotelRequest?.checkOutDate)}} </span>
                            </div>
                        </div>
                        </div>
                      <table class="styled-tables ">
                        <thead>
                          <tr >
                            <!-- Dynamic headers based on tableHeaders array -->
                            <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> hotel</mat-icon>Room Type
                            </th>
                            <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Meal Plan</th>
                            <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> groups</mat-icon>Guest Name  </th>
                                  <!-- <th style="padding: 8px;  text-align: center;"  >Seat Map</th> -->
                                 

                            <!-- <th *ngIf="!showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" (click)="seatWindow()">Seat Selection </th>
                            <th *ngIf="showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">Seat Selection  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></th> -->



                          </tr>
                        </thead>
                        <tbody>
                          <!-- Iterate through dynamic data rows -->

                          <tr *ngFor="let room of element?.hotelItineraries">
                            <td style="padding: 8px; text-align: center;">
                              {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.description }}
                            </td>
                            <td style="padding: 8px; text-align: center;">
                              {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.name  }}
                            </td>
                            <td style="padding: 8px; text-align: center;">
                              <div *ngFor="let guest of room.orderPassengerDetails ">
                                {{ guest?.passengerTitle}}  {{ guest?.firstName}}  {{ guest?.lastName}} <br>
                                <!-- {{'Adult'}} -->
                                {{guest.type==="ADT"?("Adult"):guest.type==="CHD"?("Child"):guest.type==="INF"?("Infant"):''}}
                                <mat-divider ></mat-divider>
                              </div>
                            </td>
                          
                          </tr>
                          
                        </tbody>
                      </table>


                      
                     <!-- <div class="col-md-12 d-flex justify-content-start mt-2">
                    <div class="col-md-6 row">
                    <span class="col-md-5 bold">Payment Status</span>
                    <span class="col-md-7"> 
                      {{element?.paymentStatus==='P'?('PAID'):''}}
                      {{element?.paymentStatus==='F'?('FAILED'):''}}
                      {{element?.paymentStatus==='I'?('INITIATED'):''}}
                      {{element?.paymentStatus==='A'?('ABORTED'):''}}
                    </span>
                    </div>
                    <div class="col-md-6 row">
                      <span class="col-md-5 bold">Supplier Service Time</span>
                      <span class="col-md-7"> {{element?.bookingTs?(element?.bookingRequestTs?(supplierService(element?.bookingTs,element?.bookingRequestTs)):'-'):'-'}}</span>
                      </div>
      
                    </div> -->
                    <!-- <div class="col-md-12 d-flex justify-content-start mt-2">
                      <div class="col-md-6 row">
                      <span class="col-md-5 bold">Locked By/ Assigned To</span>
                      <span class="col-md-7">{{"-"}}</span>
                      </div>
                      <div class="col-md-6 row">
                        <span class="col-md-5 bold">User/Agent Service Time</span>
                        <span class="col-md-7"> {{element?.bookingRequestTs?(ServiceUser(element?.bookingRequestTs,element?.creationTs)):'-'}}</span>
                        </div>
                      </div> -->
                      <!-- <div class="col-md-12 d-flex justify-content-start mt-2">
                        <div class="col-md-6 row">
                        <span class="col-md-5 bold">Request Id</span>
                        <span class="col-md-7">{{element?.requestUuid||'-'}}</span>
                        </div>
                        <div class="col-md-6 row">
                          <span class="col-md-5 bold">Total Service Time</span>
                          <span class="col-md-7">{{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}}</span>
                          </div>
                        </div> -->
                        <!-- <div class="col-md-12 d-flex justify-content-start mt-2">
                          <div class="col-md-6 row">
                          <span class="col-md-5 bold">Booking Platform</span>
                          <span class="col-md-7">{{element?.channel||'-'}}</span>
                          </div>
                          <div class="col-md-6 row">
                            <span class="col-md-5 bold">Ticket Issuance Status</span>
                            <span class="col-md-7" [style]="element?.airItineraries[0]?.docIssuanceStatus==='F'?('color:red'):element?.airItineraries[0]?.docIssuanceStatus==='C'?('color:green'):''">{{element?.airItineraries[0]?.docIssuanceStatus==='F'?('Not Issued'):element?.airItineraries[0]?.docIssuanceStatus==='C'?('Issued'):'N/A'}}</span>
                            </div>
                          </div> -->
                          
                          <!-- <div class="col-md-12 d-flex justify-content-start mt-2">
                            <div class="col-md-6 row">
                            <span class="col-md-5 bold">Approval Status</span>
                            <span class="col-md-7"> {{element?.approvalStatus==='SA'?('SELF APPROVED'):''}}
                              {{element?.approvalStatus==='P'?('PENDING'):''}}
                              {{element?.approvalStatus==='D'?('DECLINED'):''}}
                              {{element?.approvalStatus==='A'?('APPROVED'):''}}
              
                              {{element?.approvalStatus==='I'?('APPROVAL INITIATED'):''}}
                              {{element?.approvalStatus==='S'?('SEND FOR RECONSIDERATION'):''}}</span>
                            </div>
                            </div> -->
                      
                      </div>
                    </div>
                    </td>
                    </ng-container>
                    
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplayHWithExpand" ></tr>
                    <tr mat-row *matRowDef="let element; columns: columnsToDisplayHWithExpand;"ß
                    class="example-element-row" sticky >
                    </tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedHDetail']"  class="example-detail-row"></tr>
                    <tr class="mat-row" *matNoDataRow>
                    <td  class="mat-cell" colspan="4">There is no data in this table</td>
                    </tr>
                    </table>
                </div>
                </mat-tab>
                <mat-tab [disabled]="true" >
                  <ng-template mat-tab-label  >
                    <span style="background-color: #3F50B5;color: #fff;padding: 10px;border-radius: 4px;padding-top: 2px;"  matBadgeSize="medium" matBadgeOverlap="false">Cab Required  : {{tripResponse.cabRequired==='true'?('Yes'):'No' }}<mat-icon *ngIf="tripResponse.cabRequired==='true'" (click)="popoveritemContent.toggle($event)" style="padding-top: 10px;font-size: 14px;">info</mat-icon>
  
                      </span>
                    </ng-template>
                  
                    <p-overlayPanel   #popoveritemContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                    <span *ngIf="tripResponse.cabLocation"> <strong>Google Location :</strong> {{tripResponse.cabLocation}}</span><br>
                    <span ><strong> Address :</strong> {{tripResponse.cabAddress}}</span><br>
                     <span ><strong>PickUp Time :</strong> {{tripResponse.cabPickUpTime}}</span>

                    </p-overlayPanel>
                  </mat-tab>
                <mat-tab [disabled]="true" >
                  <ng-template mat-tab-label  >
                     &nbsp;<span style="background-color: #3F50B5;color: #fff;padding: 10px;border-radius: 4px;"  matBadgeSize="medium" matBadgeOverlap="false">{{tripResponse?.tripUid}} </span>
                    </ng-template> </mat-tab>
                </mat-tab-group>        
                </div>
        </div>
    </div>
</div>



<p-dialog header="Status" [modal]="true" [(visible)]="ShowPopup" [style]="{ width: '50rem' }">
  <div *ngIf="showPending===false" class="success-container">
    <!-- <h1 class="success-text">Booked Successfully</h1> -->
        <h1 class="success-text">{{tripResponse?.statusDesc}}</h1>

  </div>
  <p-progressSpinner *ngIf="showPending===true"
    styleClass="w-4rem h-4rem" 
    strokeWidth="8" 
    fill="var(--surface-ground)" 
    animationDuration=".5s" />
<ng-template pTemplate="footer">
  <div class="flex justify-content-end gap-2 mt-3">
    
    <p-button label="Cancel" severity="secondary" (click)="ShowPopup = false" />
    &nbsp;
    <!-- <p-button *ngIf="tripEnable===false" label="BOOK" (click)="booking();verifyShow = false" /> -->
    <!-- <p-button *ngIf="tripEnable===true" label="Submit" (click)="submitRequest()" routerLink="/app/trip-summary"  /> -->

</div>
</ng-template>
</p-dialog>



<div *ngIf="showScreen" class="action-screen-container">
  <h2 *ngIf="currentRoute==='approval-trip'">Approve</h2>
  <h2 *ngIf="currentRoute==='reject-trip'">Reject</h2>

  <div class="comment-section">
    <label for="comment" class="comment-label">Add your Comment:</label>
    <textarea id="comment" placeholder="Write your comment here..." [(ngModel)]="comment"></textarea>
  </div>

  <div class="button-group">
    <button style="margin-right: 10px;"  class="reject-button" (click)="cancel()">Cancel</button>

    <button *ngIf="currentRoute==='approval-trip'" class="approve-button" (click)="onApprove()">Approve</button>
    <button *ngIf="currentRoute==='reject-trip'" class="reject-button" (click)="onReject()">Reject</button>
  </div>
</div>




<div *ngIf="successPopup" class="overlay">  
  <!-- <div class="overlay">  -->
 <div class="success">
   <div class="col-md-12 row" style="padding-top: 20px;">
     <div class=" col-md-4"></div>
     <div  class="col-md-1"style=" display: flex; justify-content: center;padding-top: 25px;"><img src="../../../assets/images/star.png" width="10px"></div>
     <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 15px;"><img src="../../../assets/images/star.png" width="20px"></div>
     <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 25px;"><img src="../../../assets/images/star.png" width="15px"></div>
     <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 30px;"><img src="../../../assets/images/star.png" width="10px"></div>
   </div>
<div class="col-md-12 row">
 <div class="col-md-3"></div>
 <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 75px;"><img src="../../../assets/images/star.png" width="15px"></div>
 <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 65px;"><img src="../../../assets/images/star.png" width="20px"></div>
 <div class="col-md-2" style=" display: flex; justify-content: center;padding-top: 10px;">
 <img *ngIf="action==='A'"  src="../../../assets/images/check.jpeg" width="80px">
 <img *ngIf="action==='D'"  src="../../../assets/images/crosss.png" width="80px">

</div>
<div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 75px;"><img src="../../../assets/images/star.png" width="15px"></div>
</div>

<div class="col-md-12 row">
 <div class="col-md-1"></div>
 <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 95px;"><img src="../../../assets/images/star.png" width="10px"></div>
 <!-- <div class="col-md-12 drName " style="text-align: center;">
  <span class="drName " style="text-align: center;color: grey;">{{'Trip Approved Successfully'}} </span>
  </div> -->
 <div *ngIf="action==='A'"  class="col-md-9 usrAddScc" style=" display: flex; justify-content: center; padding-top: 25px;color: grey;"> Trip Approved Successfully</div>
 <div *ngIf="action==='D'"  class="col-md-9 usrAddScc" style=" display: flex; justify-content: center; padding-top: 25px;color: grey;"> Trip Rejected</div>

 <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 85px;"><img src="../../../assets/images/star.png" width="15px"></div>
 <div class="button-group">
  <button *ngIf="action==='D'" style="margin-right: 10px;"  class="reject-button" (click)="cancel()">OK</button>
  <button *ngIf="action==='A'" style="margin-right: 10px;"  class="approve-button" (click)="cancel()">OK</button>

</div>
</div>

<!-- <div class="col-md-12 drName " style="text-align: center;">
<span>Agent Name:</span><span>{{'userName'}} </span>
</div>
<div class="col-md-12 "  style="text-align: center;">
<span>Email: </span><span>{{'emailId'}} </span>
 </div> -->
 <div class="col-md-12 row">
   <div class="col-md-4"></div>
   <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 20px;"><img src="../../../assets/images/star.png" width="10px"></div>
   <div class="col-md-1"></div>
   <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 15px;"><img src="../../../assets/images/star.png" width="15px"></div>
   <div class="col-md-3"></div>
 </div>
</div>
</div>





